import { AxiosResponse } from "axios";
import axiosClient from "../../common/axios/axiosConfig";
import { IResendPatientAccess } from "../../common/interfaces/IResendPatientAccess";
import useQuery from "../../utils/useQuery";

interface IResponse {
  email?: boolean;
  sms?: boolean;
  whatsappUrl?: string;
}

export const resendPatientAccess = (
  info: IResendPatientAccess
): Promise<AxiosResponse<IResponse>> => {
  const telemedicineToken = useQuery().get("token") || "";

  return axiosClient.post(`/room/send-access`, info, {
    headers: {
      Authorization: `Bearer ${telemedicineToken}`
    }
  });
};
